import http from "../http-common";

class SchoolDashboardService {
  getStats() {
    return http.get('/dashboard/school-stats');
  }
}

export default new SchoolDashboardService();
